import { useAuth } from '../../contexts/auth'
import React from 'react'
import { Navigate, RouteProps, Outlet } from 'react-router-dom'

const UnProtectedRoute: React.FC<RouteProps> = () => {
  const { user } = useAuth()

  if (!!user) {
    return <Navigate to='/' replace />
  }

  return <Outlet />
}

export default UnProtectedRoute
